<template>
  <v-container fluid class="pa-0 ma-3">
    <v-btn
      class="ma-2"
      @click="exportToExcel"
      append-icon="mdi-file-excel"
      variant="outlined"
      >Excel</v-btn
    >
    <v-btn
      class="ma-2"
      @click="print"
      append-icon="mdi-printer"
      variant="outlined"
      >print</v-btn
    >

    <v-container>
      <v-div id="printArea" dir="rtl">
        <v-data-table v-model="selected" :items="diff_data" :headers="headers">
          <template v-slot:no-data>
            <h3>No data available</h3>
          </template>
        </v-data-table>
      </v-div>
    </v-container>
  </v-container>
  <overlay-loader v-model="loading" />
</template>

<script>
import swalFun from "@/plugins/swalFun";
import OverlayLoader from "@/components/common/OverlayLoader.vue";

import * as XLSX from "xlsx";
import { api } from "@/plugins/api";

export default {
  components: {
    OverlayLoader,
  },
  data: () => ({
    headers: [
      { title: "العلبة", key: "parent.name" },
      { title: "الاستهلاك", key: "parent_consumption" },
      { title: "استهلاك الأبناء", key: "children_consumption" },
      { title: "فرق الاستهلاك", key: "diff" },
    ],
    loading: false,
    dialog: false,
    diff_data: [],
  }),
  computed: {
    dataToExport() {
      const res = this.diff_data.map(
        ({ parent, parent_consumption, children_consumption }) => {
          return {
            العلبة: parent.name,
            الاستهلاك: parent_consumption,
            الأبناء: children_consumption,
            الفرق: parent_consumption - children_consumption,
          };
        }
      );
      return res;
    },
  },
  methods: {
    exportToExcel() {
      const worksheet = XLSX.utils.json_to_sheet(this.dataToExport);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, "data.xlsx");
    },
    print() {
      const printElement = document.getElementById("printArea");
      if (!printElement) {
        console.error("Element not found");
        return;
      }

      const printContent = printElement.innerHTML;
      const printWindow = window.open("", "_blank", "width=800,height=600");

      printWindow.document.write(`
    <html>
        <head>
            <title>Print Content</title>
            <style>
                @media print {
                    body {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 0;
                        height: 100vh;  /* Ensure the body takes full height */
                        padding: 20px;
                        box-sizing: border-box; /* Include padding in width calculations */
                    }
                    @page {
                        margin: 0;
                    }
                }
            </style>
        </head>
        <body dir=rtl>
            ${printContent}
        </body>
    </html>
`);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    },

    async fetch() {
      this.loading = true;

      try {
        const response = await api.get(`/reports/diff`);
        const res = response.data.data;
        console.log("response", res);
        this.diff_data = res;
        if (res) {
          //
        }
      } catch (error) {
        swalFun.fail("error");
      }

      this.loading = false;
    },
  },
  async mounted() {
    await this.fetch();
  },
};
</script>
